<ion-header class="position-relative" mode="md">
  <ion-toolbar class="home__header" lines="none">
    <ion-buttons slot="start" class="ion-no-margin">
      <!-- class="ion-margin-end" -->
      <ion-menu-button slot="start"></ion-menu-button>
    </ion-buttons>
    <!-- <ion-item lines="none" class="ion-text-center"> -->
    <!-- <img *ngIf="p.renderMobile && logoUrl" class="logo" [src]="logoUrl" /> -->
    <ion-item *ngIf="p.renderMobile" lines="none" class="ion-text-center">
      <ion-text class="welcome-text">
        {{'WELCOME_HEADER_TEST' | translate}} {{userName}}!
      </ion-text>
    </ion-item>
    <!-- </ion-item> -->
    <ion-buttons slot="end" class="ion-no-margin">
      <ion-button
        *ngIf="productCounter"
        fill="clear"
        [ngClass]="{'w-57': productCounter > 9}"
        shape="round"
        (click)="onCartClick()"
      >
        <ion-icon
          class="cart"
          src="./assets/icons/basket.svg"
          slot="start"
        ></ion-icon>
        <ion-text class="counter">{{ productCounter }}</ion-text>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <app-user-settings
    class="home__user-settings"
    mobileViewBreakPoint="992"
  ></app-user-settings>
</ion-header>

<ion-fab horizontal="end" vertical="bottom" slot="fixed" *ngIf="p.renderMobile">
  <ion-fab-button (click)="presentActionSheet()">
    <ion-icon name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>

<ion-content [ngClass]="{'refreshing-lock': refreshing}" #content scrollbar>
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-grid class="no-padding-horizontal">
    <ion-row class="header" *ngIf="!p.renderMobile">
      <ion-col>
        <img [src]="bannerImageUrl" class="home__header-image" />
      </ion-col>
    </ion-row>

    <ion-row class="content-tile__outher-container" #tilesContainer>
      <ng-container *ngFor="let info of statsInfoPages">
        <ion-col
          *appHasRole="[info.viewRole]"
          [attr.size-xl]="statsInfoPages?.length == 5 ? 'auto' : statsInfoPages?.length == 6 ? '4' : '3'"
          size-lg="6"
          class="content-tile__container"
          #tilesContainer
        >
          <app-info-tile [info]="info"></app-info-tile>
        </ion-col>
      </ng-container>
    </ion-row>

    <img
      *ngIf="p.renderMobile && logoMobileUrl"
      class="home__header-image"
      [src]="logoMobileUrl"
    />

    <!-- sekcja PRZYPISANE MIEJSCA PARKINGOWE i REZERWACJE -->

    <ng-container *ngIf="userServ.checkModule(appModule.Reception)">
      <ng-container *appHasRole="['parking.home']">
        <ng-container *ngIf="showParkingAssignments">
          <ion-row
            class="content content-header-title"
            (click)="toggleParkingAssignments()"
          >
            <ion-col class="section__title">
              <ion-text
                >{{'MENU.ASSIGNED_PARKING_SPACES' | translate }}</ion-text
              >
              <ion-icon
                class="header-title-arrow"
                size="large"
                name="chevron-down-outline"
                [@toggleRotate]="!userSession.homeHideParkingAssignments ? 'active' : 'inactive'"
              >
              </ion-icon>
            </ion-col>
          </ion-row>
          <ion-row
            class="horizontal-margin-minus-5 section__container"
            [@toggleHeight]="!userSession.homeHideParkingAssignments ? 'active' : 'inactive'"
          >
            <ion-col>
              <app-pagination-client-side
                class="invitations-toggle"
                [columns]="columnsDefinitionParkingAssignments"
                [options]="optionsMyAssignments"
                [componentRef]="componentRefParkingAssignment"
                (rowsLoaderReady)="parkingAssignmentsRowsLoaderServiceReady($event)"
                (actionRequest)="refreshParkingAssignments()"
              >
              </app-pagination-client-side>
            </ion-col>
          </ion-row>
        </ng-container>

        <!-- REZERWACJE -->
        <ng-container *ngIf="showParkingBookings">
          <ion-row
            class="content content-header-title"
            (click)="toggleParkingBookings()"
          >
            <ion-col class="section__title">
              <ion-text
                >{{'MENU.ASSIGNED_PARKING_BOOKINGS' | translate }}</ion-text
              >
              <ion-icon
                class="header-title-arrow"
                size="large"
                name="chevron-down-outline"
                [@toggleRotate]="!userSession.homeHideParkingBookings ? 'active' : 'inactive'"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row
            class="horizontal-margin-minus-5 section__container"
            [@toggleHeight]="!userSession.homeHideParkingBookings ? 'active' : 'inactive'"
          >
            <ion-col>
              <app-pagination-client-side
                class="invitations-toggle"
                [columns]="columnsDefinitionParkingBookings"
                [options]="optionsMyBookings"
                [componentRef]="componentRefParkingBookings"
                (rowsLoaderReady)="parkingBookingsRowsLoaderServiceReady($event)"
                (actionRequest)="updateReservations($event)"
              >
              </app-pagination-client-side>
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- sekcja NADCHODZĄCE SPOTKANIA -->

    <ng-container *ngIf="showInvitationList">
      <ng-container *appHasRole="['invitation.home']">
        <ng-container *ngIf="userServ.checkModule(appModule.Reception)">
          <ion-row
            class="content content-header-title"
            (click)="toggleInvitations()"
          >
            <ion-col class="section__title">
              <ion-text
                >{{'MENU.MY_INVITATIONS_CURRENT' | translate }}</ion-text
              >
              <ion-icon
                class="header-title-arrow"
                size="large"
                name="chevron-down-outline"
                [@toggleRotate]="!userSession.homeHideInvitations ? 'active' : 'inactive'"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row
            class="horizontal-margin-minus-5 section__container"
            [@toggleHeight]="!userSession.homeHideInvitations ? 'active' : 'inactive'"
          >
            <ion-col>
              <app-pagination-client-side
                class="invitations-toggle"
                [columns]="columnsDefinition"
                [componentRef]="componentRef"
                [options]="options"
                (rowsLoaderReady)="invitationRowsLoaderServiceReady($event)"
              ></app-pagination-client-side>
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- sekcja PRZYSZŁE REZERWACJE -->
    <ng-container *ngIf="showBookingList">
      <ng-container *appHasRole="['booking.home']">
        <ng-container *ngIf="userServ.checkModule(appModule.Booking)">
          <ion-row
            class="content content-header-title"
            (click)="toggleBookings()"
          >
            <ion-col class="section__title">
              <ion-text>{{'MENU.MY_RESERVATIONS' | translate }}</ion-text>
              <ion-icon
                class="header-title-arrow"
                size="large"
                name="chevron-down-outline"
                [@toggleRotate]="!userSession.homeHideBookings ? 'active' : 'inactive'"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row
            class="horizontal-margin-minus-5 section__container"
            [@toggleHeight]="!userSession.homeHideBookings ? 'active' : 'inactive'"
          >
            <ion-col>
              <app-pagination-client-side
                [columns]="columnsDefinitionBookings"
                [componentRef]="componentRefReservations"
                [options]="options"
                (rowsLoaderReady)="bookingRowsLoaderServiceReady($event)"
              ></app-pagination-client-side>
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- sekcja POPULARNE PRODUKTY -->
    <ng-container *appHasRole="['market.home']">
      <ng-container
        *ngIf="userServ.checkModule(appModule.Market) && products?.length > 0"
      >
        <ion-row
          class="content content-header-title"
          (click)="toggleProducts()"
        >
          <ion-col>
            <span class="section__title">
              <ion-text>{{'MENU.POPULAR_PRODUCTS' | translate }} </ion-text>
              <ion-icon
                class="header-title-arrow"
                size="large"
                name="chevron-down-outline"
                [@toggleRotate]="!userSession.homeHideProducts ? 'active' : 'inactive'"
              ></ion-icon>
            </span>
          </ion-col>
        </ion-row>

        <ion-row
          class="overflow-ellipsis pos-relative horizontal-margin-minus-10 section__container"
          [@toggleHeight]="!userSession.homeHideProducts ? 'active' : 'inactive'"
        >
          <ion-col *ngIf="p.renderMobile">
            <swiper
              class="swiper"
              [config]="slideOpts"
              [pagination]="{ clickable: true }"
            >
              <ng-template
                swiperSlide
                class="swiper-slide"
                *ngFor="let product of products"
              >
                <app-product-tile
                  [product]="product"
                  [userServ]="userServ"
                  [showProviderName]="true"
                  (showCart)="onShowCart($event)"
                  class="move-on-hover cursor-pointer"
                ></app-product-tile>
              </ng-template>
            </swiper>
          </ion-col>

          <ng-container *ngIf="!p.renderMobile">
            <ion-col *ngFor="let product of products" size="4">
              <app-product-tile
                [product]="product"
                [userServ]="userServ"
                [showProviderName]="true"
                (showCart)="onShowCart($event)"
                class="move-on-hover cursor-pointer"
              ></app-product-tile>
            </ion-col>
          </ng-container>

          <div class="home__slider-cover-for-menu-swipe"></div>
        </ion-row>
      </ng-container>
    </ng-container>

    <!-- sekcja AKTUALNOŚCI -->
    <ng-container *ngIf="showCommunityList">
      <ng-container *appHasRole="['community.home']">
        <ng-container
          *ngIf="userServ.checkModule(appModule.Community) && communities?.length > 0"
        >
          <ion-row
            class="content content-header-title"
            (click)="toggleCommunity()"
          >
            <ion-col>
              <span class="section__title">
                <ion-text>{{'MENU.LATEST_NEWS' | translate }}</ion-text>
                <ion-icon
                  class="header-title-arrow"
                  size="large"
                  name="chevron-down-outline"
                  [@toggleRotate]="!userSession.homeHideCommunity ? 'active' : 'inactive'"
                ></ion-icon>
              </span>
            </ion-col>
          </ion-row>

          <ion-row
            class="overflow-ellipsis pos-relative horizontal-margin-minus-10 section__container"
            [@toggleHeight]="!userSession.homeHideCommunity ? 'active' : 'inactive'"
          >
            <ion-col *ngIf="p.renderMobile">
              <swiper
                class="swiper"
                [config]="slideOpts"
                [pagination]="{ clickable: true }"
              >
                <ng-template
                  swiperSlide
                  class="swiper-slide"
                  *ngFor="let community of communities"
                >
                  <app-community-tile
                    [community]="community"
                    [userServ]="userServ"
                  ></app-community-tile>
                </ng-template>
              </swiper>
            </ion-col>

            <ng-container *ngIf="!p.renderMobile">
              <ion-col
                size="4"
                size-lg="4"
                size-xl="3"
                *ngFor="let community of communities"
              >
                <app-community-tile
                  [community]="community"
                  [userServ]="userServ"
                  class="move-on-hover cursor-pointer"
                >
                </app-community-tile>
              </ion-col>
            </ng-container>

            <div class="home__slider-cover-for-menu-swipe"></div>
          </ion-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- koniec sekcji AKTUALNOŚCI -->
  </ion-grid>
</ion-content>
